import React from "react";

export function AmbientBackground() {
  return (
    <div className="pointer-events-none absolute top-0 left-0 right-0 h-[600px] z-0">
      <div className="absolute inset-0 bg-gradient-to-b from-[#1e1b4b] via-[#0f172a] to-[#05050f]" />
      <div className="absolute top-[-10%] left-[20%] w-[600px] h-[600px] bg-purple-600/20 blur-[100px] rounded-full mix-blend-screen" />
      <div className="absolute top-[10%] right-[10%] w-[500px] h-[500px] bg-blue-600/20 blur-[100px] rounded-full mix-blend-screen" />
    </div>
  );
}
